/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

export function observeMethod<T>(obj: T, methodName: keyof T): Observable<unknown> {
  const CACHE_KEY = `__NgFalcon_observeMethod_${String(methodName)}`;

  if (obj[CACHE_KEY]) {
    return obj[CACHE_KEY] as Observable<unknown>;
  }

  const observable = new Observable<unknown>(subscriber => {
    const originalMethod = obj[methodName] as unknown as Function;

    (obj[methodName] as any) = function () {
      const result = originalMethod.apply(obj, arguments);

      subscriber.next();
      return result;
    };

    return {
      unsubscribe(): void {
        (obj[methodName] as any) = originalMethod;
        delete obj[CACHE_KEY];
      }
    };
  }).pipe(share());

  Object.defineProperty(obj, CACHE_KEY, { value: observable, writable: true, enumerable: false, configurable: true});
  return observable;
}
